import * as React from "react";
interface SVGProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const SvgAndroid = (props: SVGProps) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 120 36" fill="none" {...props}>
      <path
        d="M115.556 35.927H4.444A4.401 4.401 0 010 31.482V4.816A4.401 4.401 0 014.444.37h111.112A4.401 4.401 0 01120 4.816v26.666c0 2.4-1.956 4.445-4.444 4.445z"
        fill="#000"
      />
      <path
        d="M115.556 1.082c2.044 0 3.733 1.69 3.733 3.734v26.666c0 2.045-1.689 3.733-3.733 3.733H4.444c-2.044 0-3.733-1.688-3.733-3.733V4.816c0-2.045 1.689-3.734 3.733-3.734h111.112zm0-.71H4.444A4.401 4.401 0 000 4.815v26.666a4.401 4.401 0 004.444 4.445h111.112A4.401 4.401 0 00120 31.482V4.816c0-2.4-1.956-4.445-4.444-4.445z"
        fill="#A6A6A6"
      />
      <path
        d="M42.133 9.438c0 .71-.178 1.333-.622 1.777-.533.534-1.156.8-1.956.8s-1.422-.266-1.955-.8c-.533-.533-.8-1.155-.8-1.955s.267-1.422.8-1.956c.533-.533 1.155-.8 1.956-.8.355 0 .71.09 1.066.267.356.178.622.356.8.622l-.444.445c-.356-.445-.8-.622-1.422-.622-.534 0-1.067.177-1.423.622-.444.355-.622.889-.622 1.51 0 .623.178 1.156.622 1.512.445.356.89.622 1.422.622.623 0 1.067-.178 1.512-.622.266-.267.444-.622.444-1.067h-1.956v-.622h2.578v.267zM46.222 7.215h-2.4v1.689h2.222v.622h-2.222v1.689h2.4v.711h-3.11V6.593h3.11v.622zM49.156 11.926h-.712V7.215h-1.51v-.622h3.733v.622h-1.511v4.711zM53.244 11.926V6.593h.712v5.333h-.712zM56.978 11.926h-.711V7.215h-1.511v-.622H58.4v.622h-1.511v4.711h.089zM65.422 11.216c-.533.533-1.155.8-1.955.8s-1.423-.267-1.956-.8c-.533-.534-.8-1.156-.8-1.956s.267-1.422.8-1.956c.533-.533 1.156-.8 1.956-.8s1.422.267 1.955.8c.534.534.8 1.156.8 1.956s-.266 1.422-.8 1.956zm-3.377-.445c.355.356.888.622 1.422.622.533 0 1.066-.178 1.422-.622.356-.356.622-.889.622-1.511 0-.622-.178-1.156-.622-1.511-.356-.356-.889-.622-1.422-.622-.534 0-1.067.177-1.422.622a2.144 2.144 0 00-.623 1.511c0 .622.178 1.155.623 1.511zM67.2 11.926V6.593h.8l2.578 4.178V6.593h.71v5.333h-.71l-2.756-4.355v4.356H67.2z"
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.2}
        strokeMiterlimit={10}
      />
      <path
        d="M60.533 19.748c-2.133 0-3.822 1.6-3.822 3.822a3.794 3.794 0 003.822 3.822c2.134 0 3.823-1.6 3.823-3.822 0-2.311-1.69-3.822-3.823-3.822zm0 6.044c-1.155 0-2.133-.978-2.133-2.311s.978-2.311 2.133-2.311c1.156 0 2.134.889 2.134 2.31 0 1.334-.978 2.312-2.134 2.312zm-8.266-6.044c-2.134 0-3.823 1.6-3.823 3.822a3.794 3.794 0 003.823 3.822c2.133 0 3.822-1.6 3.822-3.822 0-2.311-1.689-3.822-3.822-3.822zm0 6.044c-1.156 0-2.134-.978-2.134-2.311s.978-2.311 2.134-2.311c1.155 0 2.133.889 2.133 2.31 0 1.334-.978 2.312-2.133 2.312zM42.4 20.903v1.6h3.822c-.089.889-.444 1.6-.889 2.045-.533.533-1.422 1.155-2.933 1.155-2.4 0-4.178-1.866-4.178-4.267 0-2.4 1.867-4.266 4.178-4.266 1.244 0 2.222.533 2.933 1.155l1.156-1.155c-.978-.89-2.222-1.6-4-1.6-3.2 0-5.956 2.666-5.956 5.866 0 3.2 2.756 5.867 5.956 5.867 1.778 0 3.022-.533 4.089-1.689C47.644 24.548 48 23.036 48 21.881c0-.356 0-.711-.089-.978H42.4zm40.355 1.245c-.355-.89-1.244-2.4-3.2-2.4-1.955 0-3.555 1.51-3.555 3.822 0 2.133 1.6 3.822 3.733 3.822 1.69 0 2.756-1.067 3.111-1.689l-1.244-.889c-.444.622-.978 1.067-1.867 1.067s-1.422-.356-1.866-1.156l5.066-2.133-.178-.444zM77.6 23.392c0-1.422 1.156-2.222 1.956-2.222.622 0 1.244.355 1.422.8L77.6 23.392zm-4.178 3.645h1.69V15.925h-1.69v11.111zm-2.666-6.49c-.445-.444-1.156-.888-2.045-.888-1.867 0-3.644 1.689-3.644 3.822s1.689 3.733 3.644 3.733c.889 0 1.6-.444 1.956-.889h.088v.534c0 1.422-.8 2.222-2.044 2.222-.978 0-1.689-.711-1.867-1.333l-1.422.622c.445.978 1.511 2.222 3.378 2.222 1.956 0 3.556-1.155 3.556-3.911v-6.756h-1.6v.623zM68.8 25.793c-1.156 0-2.133-.978-2.133-2.311s.977-2.311 2.133-2.311c1.156 0 2.044.978 2.044 2.31 0 1.334-.888 2.312-2.044 2.312zm21.689-9.867h-4v11.111h1.689V22.86h2.31c1.868 0 3.645-1.334 3.645-3.467s-1.777-3.467-3.644-3.467zm.089 5.334h-2.4v-3.823h2.4c1.244 0 1.955 1.067 1.955 1.867-.089.978-.8 1.956-1.955 1.956zm10.222-1.6c-1.245 0-2.489.533-2.933 1.689l1.51.622c.356-.622.89-.8 1.512-.8.889 0 1.689.533 1.778 1.422v.089c-.267-.178-.978-.445-1.689-.445-1.6 0-3.2.89-3.2 2.49 0 1.51 1.333 2.488 2.755 2.488 1.156 0 1.689-.533 2.134-1.066h.089v.889h1.6V22.77c-.178-1.956-1.689-3.111-3.556-3.111zm-.178 6.133c-.533 0-1.333-.267-1.333-.978 0-.889.978-1.155 1.778-1.155.711 0 1.066.178 1.511.355-.178 1.067-1.067 1.778-1.956 1.778zm9.334-5.867l-1.867 4.8H108l-1.956-4.8h-1.777l2.933 6.756-1.689 3.733h1.689l4.533-10.489h-1.777zm-14.934 7.111h1.69v-11.11h-1.69v11.11z"
        fill="#fff"
      />
      <path
        d="M9.244 7.038c-.266.267-.444.711-.444 1.245v19.644c0 .533.178.978.444 1.244l.09.09 11.021-11.023v-.178L9.245 7.038z"
        fill="url(#android_svg__paint0_linear)"
      />
      <path
        d="M24 21.972l-3.645-3.645v-.266L24 14.416l.089.089 4.355 2.489c1.245.71 1.245 1.866 0 2.578L24 21.972z"
        fill="url(#android_svg__paint1_linear)"
      />
      <path
        d="M24.089 21.881l-3.733-3.733L9.244 29.259c.445.444 1.067.444 1.867.089L24.09 21.88z"
        fill="url(#android_svg__paint2_linear)"
      />
      <path
        d="M24.089 14.417L11.11 7.039c-.8-.445-1.422-.356-1.867.089L20.356 18.15l3.733-3.733z"
        fill="url(#android_svg__paint3_linear)"
      />
      <path
        opacity={0.2}
        d="M24 21.794l-12.889 7.29c-.711.444-1.333.355-1.778 0l-.089.088.09.09c.444.355 1.066.444 1.777 0L24 21.793z"
        fill="#000"
      />
      <path
        opacity={0.12}
        d="M9.244 29.083c-.266-.266-.355-.71-.355-1.244v.089c0 .533.178.977.444 1.244v-.089h-.089zM28.444 19.303L24 21.794l.089.088 4.355-2.489c.623-.355.89-.8.89-1.244 0 .444-.356.8-.89 1.155z"
        fill="#000"
      />
      <path
        opacity={0.25}
        d="M11.111 7.127l17.334 9.867c.533.355.888.71.888 1.155 0-.444-.266-.889-.888-1.244L11.11 7.038C9.867 6.327 8.89 6.95 8.89 8.371v.09c0-1.423.978-2.045 2.222-1.334z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="android_svg__paint0_linear"
          x1={19.378}
          y1={8.113}
          x2={4.46}
          y2={23.031}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset={0.007} stopColor="#00A1FF" />
          <stop offset={0.26} stopColor="#00BEFF" />
          <stop offset={0.512} stopColor="#00D2FF" />
          <stop offset={0.76} stopColor="#00DFFF" />
          <stop offset={1} stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="android_svg__paint1_linear"
          x1={30.075}
          y1={18.151}
          x2={8.567}
          y2={18.151}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset={0.409} stopColor="#FFBD00" />
          <stop offset={0.775} stopColor="orange" />
          <stop offset={1} stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="android_svg__paint2_linear"
          x1={22.068}
          y1={20.189}
          x2={1.839}
          y2={40.419}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset={1} stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="android_svg__paint3_linear"
          x1={6.486}
          y1={0.529}
          x2={15.52}
          y2={9.562}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset={0.069} stopColor="#2DA771" />
          <stop offset={0.476} stopColor="#15CF74" />
          <stop offset={0.801} stopColor="#06E775" />
          <stop offset={1} stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SvgAndroid;
